export const GET_FEEDBACK_LIST_FOR_ADMIN = "/brain/v1/superadmin/feedback/list"
export const GET_FEEDBACK_LIST_FOR_USER = "/brain/v1/conversation/feedback/list"
